<script setup lang="ts">
// Privacy Policy, as the app shows it (components/LegalPage.vue).
</script>

<template>
  <LegalPage doc="privacy" />
</template>
